<template>
    <div>

        <div v-if="loading" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-else>
            <el-form @submit.native.prevent="onSubmitHorarios" :model="dados" ref="dados" label-position="top">
                <div class="container-table tabela-horarios u-mt-30">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 100px;"></th>
                                <th class="u-text-center">Segunda</th>
                                <th class="u-text-center">Terça</th>
                                <th class="u-text-center">Quarta</th>
                                <th class="u-text-center">Quinta</th>
                                <th class="u-text-center">Sexta</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in paramId.qtd_horarios">
                                <td class="u-text-center">{{item}}º Horário</td>
                                <td>
                                    <el-form-item :prop="`[1][${item}]`" :rules="[$requiredChange]" :key="i">
                                        <el-select v-model="dados[1][item]">
                                            <el-option v-for="(item, i) in areasConhecimentos" :key="i" :label="item.temp" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="`[2][${item}]`" :rules="[$requiredChange]" :key="i">
                                        <el-select v-model="dados[2][item]">
                                            <el-option v-for="(item, i) in areasConhecimentos" :key="i" :label="item.temp" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="`[3][${item}]`" :rules="[$requiredChange]" :key="i">
                                        <el-select v-model="dados[3][item]">
                                            <el-option v-for="(item, i) in areasConhecimentos" :key="i" :label="item.temp" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="`[4][${item}]`" :rules="[$requiredChange]" :key="i">
                                        <el-select v-model="dados[4][item]">
                                            <el-option v-for="(item, i) in areasConhecimentos" :key="i" :label="item.temp" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="`[5][${item}]`" :rules="[$requiredChange]" :key="i">
                                        <el-select v-model="dados[5][item]">
                                            <el-option v-for="(item, i) in areasConhecimentos" :key="i" :label="item.temp" :value="item.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div class="u-text-right u-mt-15">
                            <el-button size="small" type="danger" @click="$emit('close')">FECHAR</el-button>
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

        </div>

    </div>
</template>
<script>

export default {
    props: ['paramId', 'instituicao', 'periodo_letivo'],
    data: () => ({
        test: '',
        loading: false,
        editTurma: false,        
        dados:{
            '1': {},
            '2': {},
            '3': {},
            '4': {},
            '5': {}
        },
        areasConhecimentos: []
                
    }),
    mounted(){

        this.getHorariosByTurmaId();
        this.initFormHorarios();
    },
    methods:{

        getHorariosByTurmaId(){

            this.loading = true;

            let i = this.$store.state.config.instituicao.id;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getParamHorarios/${i}/${this.paramId.id}`, this.$store.getters.getHeaderAuth).then(response => {

                if(!response.data) {

                    for(let i in this.dados) {
                        for(let j = 1; j <= this.paramId.qtd_horarios; j++) {
                            this.$set(this.dados[i], j, '')
                        }
                    }

                } else {

                    this.dados = response.data;
                }
                
                this.loading = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        initFormHorarios(){

            this.areasConhecimentos = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/getAllByTurmaForFrequencia/${this.paramId.id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.areasConhecimentos = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        loadingHorarios(){

            this.loading = true;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/modelo/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.loading = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },

        onSubmitHorarios(){
            this.$refs.dados.validate((valid) =>{ if(valid){

                let payload = {
                    [this.paramId.id]: this.dados
                };
                
                window.eventBus.$emit('loading', true);

                let i = this.$store.state.config.instituicao.id;

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeParamHorarios/${i}`, payload, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$emit('onSubmitHorarios');

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Preencha todos os horários.', type: 'warning'});
            }});           
        },
    }
}
</script>
<style>

    .tabela-horarios table td, .tabela-horarios table th {
        border: 1px solid #adadad;
    }

</style>